/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable sort-keys */
import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   EventEmitter,
   Input,
   OnInit,
   Output,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { ProviderCallRateInput, Providers } from 'generated/graphql-types';
import { Subscription } from 'rxjs';
import { accountPhoneNumbersRoute } from 'src/app/app-routing.module';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { DetailView } from 'src/app/common-components/detail/detail-view';
import { getProviders, providerSearch } from 'src/app/common-components/helpers/provider-helper';
import { CallCostPrivileges } from '../../call-cost-register/models/call-cost-privileges';
import { SchedulePrivileges } from '../../schedule-register/models/schedule-privileges';
import { CallCostDetailSaveEvent } from '../models/call-cost-detail-form-submit-event';
import { CallCostDetailView } from '../models/call-cost-detail-view.model';
import { CallCostDetailFormService } from '../services/call-cost-detail-form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-call-cost-detail-view',
    styleUrls: ['./call-cost-detail-view.component.scss'],
    templateUrl: './call-cost-detail-view.component.html',
    standalone: false
})
export class CallCostDetailViewComponent extends DetailView implements OnInit {
   @Input() get callCost(): CallCostDetailView | null {
      return this._callCost;
   }

   set callCost(value: CallCostDetailView | null) {
      this._callCost = value;
      if (value) {
         this.formService.updateCallCost(value);
      }
   }

   @Input() set callCostPrivileges(privileges: CallCostPrivileges) {
      this._callCostPrivileges = privileges;
      if (!privileges?.canEdit) {
         this.form.disable();
      }
   }

   get schedulePrivileges(): SchedulePrivileges {
      return this._callCostPrivileges;
   }

   @Input() callState: CallState;

   @Output() formSaveCanceled = new EventEmitter<void>();

   @Output() formSubmitted = new EventEmitter<CallCostDetailSaveEvent>();

   @Output() deleteCallCost = new EventEmitter<{
      providerCallRateId: number;
      destination: string | null;
   }>();

   @Output() addScheduleHour = new EventEmitter<void>();

   @Output() addClosedException = new EventEmitter<void>();

   highlightedRow: number | null = null;

   form: UntypedFormGroup;

   shouldShowDetailView = true;

   private _callCost: CallCostDetailView | null;

   private _callCostPrivileges: CallCostPrivileges;

   providers = getProviders();

   private showDetailViewSubscription: Subscription;

   private currentCallCostStatus: boolean;

   constructor(
      public formService: CallCostDetailFormService,
      private twoColumnLayoutService: TwoColumnLayoutService,
      private cdRef: ChangeDetectorRef
   ) {
      super();
      this.form = this.formService.form;
   }

   ngOnInit(): void {
      this.showDetailViewSubscription = this.twoColumnLayoutService.shouldShowDetailView$.subscribe((shouldShow) => {
         this.shouldShowDetailView = shouldShow;
         this.cdRef.markForCheck();
      });

      this.twoColumnLayoutService.deleteCallCost$.subscribe(() => {
         this.onDeleteClick();
      });
   }

   moveCursorToEnd(event: any) {}

   onSubmit(): void {
      const submitEvent = this.getFormSubmittedEvent();
      if (submitEvent) {
         this.formSubmitted.emit(submitEvent);
      }
   }

   onCancel(): void {
      this.formSaveCanceled.emit();
   }

   canDelete(): boolean {
      return this._callCostPrivileges.canDelete;
   }

   onDeleteClick(): void {
      if (this.callCost) {
         this.deleteCallCost.emit({
            destination: this.callCost.destination,
            providerCallRateId: this.callCost.providerCallRateId,
         });
      }
   }

   getRouterLink(id: number) {
      return `/${accountPhoneNumbersRoute}/${id}`;
   }

   providerDisplayWith(option: Providers): string {
      return `${option ?? ''}`;
   }

   providerSearch(searchText: string) {
      this.providers = providerSearch(searchText);
   }

   providerReset() {
      this.providers = getProviders();
   }

   private getFormSubmittedEvent(): CallCostDetailSaveEvent | null {
      if (!this.formService.form.dirty || !this.callCost) {
         return null;
      }
      const callCost = this.formService.getValue(this.callCost.providerCallRateId);

      let callCostFields: (keyof ProviderCallRateInput)[] = [];
      // callCostFields = this.formService.addFieldForDirtyControl(callCostFields, 'destination');
      // callCostFields = this.formService.addFieldForDirtyControl(callCostFields, 'area');
      // callCostFields = this.formService.addFieldForDirtyControl(callCostFields, 'zone');
      // callCostFields = this.formService.addFieldForDirtyControl(callCostFields, 'rate');
      // callCostFields = this.formService.addFieldForDirtyControl(callCostFields, 'providerId');

      return { callCost, callCostFields };
   }
}
